import { CASES } from "./constants";

/**
 * Updates user-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the users slice
 */
export const updateUsers = (payload) => {
  return { type: CASES.UPDATE_USERS, payload };
};

/**
 * Updates a specific field in the users search form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'filterForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateUsersSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_USERS_SEARCH_FORM,
    payload: { key, data },
  };
};

/**
 * Updates a specific field in the user create/edit form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'userForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateUserForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_USER_FORM,
    payload: { key, data },
  };
};

/**
 * Resets the users state to initial values, preserving role options and sort preference.
 */
export const clearUsers = () => {
  return { type: CASES.CLEAR_USERS, payload: {} };
};

/**
 * Resets the user form and selected user to initial values.
 */
export const clearUserForm = () => {
  return { type: CASES.CLEAR_USER_FORM, payload: {} };
};
